// extracted by mini-css-extract-plugin
export default {"navLinkB":"NavLinkB_navLinkB__XZ+0J","navLinkBMobile":"NavLinkB_navLinkBMobile__GZdlw","navLinkB_active":"NavLinkB_navLinkB_active__8Zhz7"};